import request from '../../utils/request'
import config from '../../config/config'
const baseURL = config.baseURL;

export function menusAdd (data) {
  return request({
    url: baseURL + '/api/menus/add',
    method: 'post',
    data: data
  })
}

export function menusList (data) {
  return request({
    url: baseURL + '/api/menus/list',
    method: 'post',
    data: data
  })
}

export function menusDelete (data) {
  return request({
    url: baseURL + '/api/menus/delete',
    method: 'post',
    data: data
  })
}

export function menusUpdate (data) {
  return request({
    url: baseURL + '/api/menus/update',    
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/menu/index.js